import axios from 'axios'
import createAuthRefreshInterceptor from 'axios-auth-refresh'
import { ADMIN_API_URL } from 'const'

// The refresh token is kept on this device, so a sign-in outlives the page.
// The sign-in iframe's own Firebase session can't: Safari takes
// auth.reclip.app inside admin.reclip.app for a third party (it compares
// origins, not sites) and holds its IndexedDB and localStorage in memory, gone
// once Safari or a Home Screen app is closed. Storage is read and written in a
// try, since a private window can refuse it; the sign-in then lasts the page.
const REFRESH_KEY = 'auth.refreshToken'

let refresh = null

export const storedRefreshToken = () => {
  try {
    return window.localStorage.getItem(REFRESH_KEY)
  } catch {
    return null
  }
}

const storeRefreshToken = (refreshToken) => {
  try {
    if (refreshToken) window.localStorage.setItem(REFRESH_KEY, refreshToken)
    else window.localStorage.removeItem(REFRESH_KEY)
  } catch {
    // Refused: the sign-in lasts as long as the page.
  }
}

// The refresh token goes in the body, never the query string: the API's
// access log records the request line, and this token mints staff access
// tokens indefinitely.
// skipAuthRefresh: exempt the refresh call itself from the interceptor below
// — if /refresh ever returned 401, it would otherwise recurse.
export const requestAccessToken = (refreshToken) =>
  axios
    .post(
      `${ADMIN_API_URL}/refresh`,
      { refresh_token: refreshToken },
      { skipAuthRefresh: true }
    )
    .then(({ data: token }) => token)

createAuthRefreshInterceptor(axios, (failedRequest) =>
  requestAccessToken(refresh).then((token) => {
    failedRequest.response.config.headers['Authorization'] = `Bearer ${token}`
    axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  })
)

export const setTokens = (token, refreshToken) => {
  axios.defaults.headers.common['Authorization'] = `Bearer ${token}`
  refresh = refreshToken
  storeRefreshToken(refreshToken)
}

export const deleteTokens = () => {
  delete axios.defaults.headers.common['Authorization']
  refresh = null
  storeRefreshToken(null)
}
